import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
}), 'LocalPharmacy');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalPharmacy.js
// module id = 4626
// module chunks = 2